import { createSelector } from '@reduxjs/toolkit';
const tableFiltersReducer = (state) => state.tablesFilters;
export const tableFiltersDataSelector = (tableId) => createSelector(tableFiltersReducer, (prefs) => prefs.inputFilters[tableId]);
export const tableFiltersForQueriesSelector = (tableId) => createSelector(tableFiltersReducer, (prefs) => prefs.filtersForQueries[tableId]);
